angular.module('bmsApp.merrymaids.job')
	.factory('MMDiscountSvc', MMDiscountSvc);

MMDiscountSvc.$inject = [
	'CRUDSvc',
];

function MMDiscountSvc(
	CRUDSvc
) {
	return {
		typeOptions: () => {
			return CRUDSvc.get('api/merrymaids/discount/type/options');
		},
		calculateDiscount: (params) => {
			return CRUDSvc.post('api/merrymaids/discount/calculate-discount', params);
		},
	};
}
